<template>
	<div class="">
		<v-col cols="12" sm="12" class="">
			<v-data-table
				v-if="hasItens"
				:headers="colunas"
				:items="itens"
				:server-items-length="totalItens"
				item-key="id"
				:options="paginacaoInterna"
				no-data-text="Não há itens cadastrados"
				hide-default-footer
				class="arp-listview row-pointer"
			>
				<template #item.descricao="{ item }">
					<texto-tooltip :texto="item.descricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
				</template>
				<template #item.valorUnitario="{ item }">
					<span> {{ item.valorUnitario | azCurrency(numeroCasasDecimaisValores) }} </span>
				</template>
				<template #item.estoqueAtual="{ item }">
					<span> {{ item.estoqueAtual | rpCurrencyFilter('', numeroCasasDecimaisQtde) }} </span>
				</template>
				<template #item.saldoDisponivelOrgao="{ item }">
					<span> {{ getSaldoDisponivelOrgao(item) | rpCurrencyFilter('', numeroCasasDecimaisQtde) }} </span>
				</template>
				<template #item.quantidadeSolicitada="{ item }">
					<az-money
						v-model="item.quantidadeSolicitada"
						:name="`Quantidade-${item.id}`"
						prefix=""
						:precision="numeroCasasDecimaisQtde"
						:disabled="!podeEditarQtdSolicitada"
						class="cell-editable"
						dense
						event-submit="blur"
						show-clear-button
						@blur="salvarItem($event, item)"
					>
					</az-money>
				</template>
			</v-data-table>

			<template-listagem-vazia :total-itens="totalItens" :textos="textos"></template-listagem-vazia>

			<paginacao-tabela
				v-if="totalItens > 0"
				:page.sync="paginacaoInterna.page"
				:rows-per-page.sync="paginacaoInterna.rowsPerPage"
				:totalPaginas="totalPaginas"
				:totalItens="totalItens"
				@resetar-page="resetarPage"
			></paginacao-tabela>
		</v-col>
		<v-input></v-input>
	</div>
</template>
<script>
import { Alert, TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import { mapState } from 'vuex'
import { actionTypes } from '@/core/constants'

export default {
	name: 'listagem-itens-adesao-view',
	components: { PaginacaoTabela, TemplateListagemVazia, TextoTooltip },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Tipo', 'tipo', '5%'),
				new TabelaColunaUtils('Seq', 'sequencia', '5%'),
				new TabelaColunaUtils('Descrição', 'descricao', '35%'),
				new TabelaColunaUtils('Un. Aquis.', 'unidadeAquisicao', '6%'),
				new TabelaColunaUtils('Razão Social', 'razaoSocial', '20%'),
				new TabelaColunaUtils('Qtd.', 'estoqueAtual', '6%'),
				new TabelaColunaUtils('Valor Unitário', 'valorUnitario', '8%'),
				new TabelaColunaUtils('Saldo disp. Órgão', 'saldoDisponivelOrgao', '7%'),
				new TabelaColunaUtils('Qtde. Solicitada', 'quantidadeSolicitada', '8%'),
			],
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontrados itens',
			},
			textoTamanhoMaximo: 80,
			alert: new Alert(this.$store),
		}
	},
	computed: {
		...mapState({
			podeEditarQtdSolicitada: (state) => state.adesaoPublica.formIsValid,
			numeroCasasDecimaisQtde: (state) => state.casasDecimais.numeroCasasDecimaisQtde,
			numeroCasasDecimaisValores: (state) => state.casasDecimais.numeroCasasDecimaisValores,
		}),
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
		async salvarItem(inputValue, item) {
			await this.$store
				.dispatch(actionTypes.ADESAO_PUBLICA.SALVAR_ITEM, {
					quantidadeSolicitada: inputValue,
					idSolicitacaoAdesao: this.$store.state.adesaoPublica.idSolicitacaoAdesao.value,
					idItemAta: item.id,
					idAta: this.$store.state.adesaoPublica.filtro.idAta.value,
				})
				.then(() => {
					item._quantidadeSolicitada = item.quantidadeSolicitada
					this.alert.showSuccess(`Operação realizada com sucesso.`)
				})
				.catch(() => (item.quantidadeSolicitada = item._quantidadeSolicitada))
		},
		getSaldoDisponivelOrgao(item) {
			if (this.podeEditarQtdSolicitada) return item.saldoDisponivelOrgao
			return null
		},
	},
}
</script>
<style scoped lang="stylus"></style>
